import { create } from "zustand";

interface StoreState {
  serviceId: string | null;
  setServiceId: (serviceId: string) => void;

  date: Date | null;
  setDate: (date: Date | null) => void;

  dates: number[];
  setDates: (dates: number[]) => void;

  isChoosingReservation: boolean;
  setIsChoosingReservation: (value: boolean) => void;

  reset: () => void;
}

export const useReservationStore = create<StoreState>((set) => ({
  serviceId: null,
  setServiceId: (serviceId: string) => set(() => ({ serviceId })),

  date: null,
  setDate: (date) => set(() => ({ date })),

  dates: [],
  setDates: (dates) => set(() => ({ dates })),

  isChoosingReservation: false,
  setIsChoosingReservation: (value) => set(() => ({ isChoosingReservation: value })),

  reset: () => set(() => ({ serviceId: null, date: null, dates: [], isChoosingReservation: false }))
}));
